// ---------
// FEATURED CATEGORIES FADE-IN "SLIDER"
// ---------

function setupFadeinSliders() {
    let sliders = document.querySelectorAll('.js-fadeSlider');

    if (sliders.length == 0) {
        return;
    }

    sliders.forEach((slider) => {
        setupSlider(slider);
    });

    function setupSlider(slider) {
        /*let slider = document.querySelector(".js-limitedSlider");*/
        let box = slider.querySelector('.js-fadeSliderBox');
        let slides = slider.querySelectorAll('.js-fadeSlide');
        let autoplay = parseInt(slider.dataset.autoplay ?? 0);

        let left = slider.querySelector('.js-left');
        let right = slider.querySelector('.js-right');
        /*console.log(slides, left, right);*/

        let isTransitioning = false;
        let oldState = 0;
        let maxState = slides.length - 1;

        //left.classList.remove("is-enabled");

        const setState = (desiredState) => {
            isTransitioning = true;
            const carouselImages = slides;
            const length = carouselImages.length;

            //left.classList.add("is-enabled");
            //right.classList.add("is-enabled");

            if (desiredState == maxState) {
                //right.classList.remove("is-enabled");
            }

            if (desiredState == 0) {
                //left.classList.remove("is-enabled");
            }

            /* console.log(desiredState);*/
            for (let index = 0; index < length; index++) {
                let image = carouselImages[index];
                if (index == desiredState) {
                    //new
                    image.classList.add('z-10');
                    image.animate({ opacity: 1 }, { duration: 300 }).onfinish =
                        () => {
                            image.classList.remove('opacity-0');
                        };
                    continue;
                }

                //old
                if (image.classList.contains('z-10')) {
                    image.classList.remove('z-10');
                    image.animate({ opacity: 0 }, { duration: 500 }).onfinish =
                        () => {
                            image.classList.add('opacity-0');
                            isTransitioning = false;
                        };
                }
            }
        };

        function goLeft() {
            if (isTransitioning) return;
            //if (!left.classList.contains("is-enabled")) return;
            let newState = oldState - 1;
            newState = newState < 0 ? maxState : newState;
            setState(newState);
            //updateNumbers(newState);
            //updateBar(newState);
            oldState = newState;
        }

        function goRight() {
            if (isTransitioning) return;
            //if (!right.classList.contains("is-enabled")) return;
            let newState = oldState + 1;
            newState = newState > maxState ? 0 : newState;
            setState(newState);
            //updateNumbers(newState);
            //updateBar(newState);
            oldState = newState;
        }

        /* mobile state bar + numbers */
        const sliderNumbers = slider.querySelectorAll('.js-sliderNumber');
        const sliderBar = slider.querySelector('.js-sliderBar');

        const updateNumbers = (desiredState) => {
            if (!sliderNumbers) return;
            if (sliderNumbers.length < 1) return;
            sliderNumbers.forEach((element, index) => {
                if (index === desiredState) {
                    element.animate(
                        { opacity: 1 },
                        { duration: 500 }
                    ).onfinish = () => {
                        element.classList.remove('opacity-0');
                    };
                } else {
                    element.animate(
                        { opacity: 0 },
                        { duration: 700 }
                    ).onfinish = () => {
                        element.classList.add('opacity-0');
                    };
                }
            });
        };

        const updateBar = (desiredState) => {
            if (!sliderBar) return;
            const percentage =
                (desiredState / (sliderNumbers.length - 1)) * 100;
            sliderBar.style.width = `${percentage}%`;
        };

        /* start autoplay if set by data attribute */
        if (autoplay > 1000) {
            const autoplayInterval = setInterval(() => {
                let newState = oldState + 1;
                //console.log(newState);
                newState = newState > maxState ? 0 : newState;
                setState(newState);
                //updateNumbers(newState);
                //updateBar(newState);
                oldState = newState;
            }, autoplay);
        }

        left ? left.addEventListener('click', goLeft) : null;
        right ? right.addEventListener('click', goRight) : null;
    }
}

export { setupFadeinSliders };
